import { render, staticRenderFns } from "./WebhookDeleteDialogue.vue?vue&type=template&id=d5145a00&"
import script from "./WebhookDeleteDialogue.vue?vue&type=script&lang=js&"
export * from "./WebhookDeleteDialogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports